import { ReactNode, lazy, Suspense } from 'react';
import { useTenantConfig } from '@packlink/tenant-config-provider';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { routePathGenerator } from '@utils/routes';
import { ErrorPage, ErrorPageTypes, Spinner } from '@components';

const Checkout = lazy(() => import(/* webpackChunkName: 'Checkout'*/ '@Checkout/pages/Checkout'));
const PostSale = lazy(() => import(/* webpackChunkName: 'PostSale'*/ '@Postsale/pages/PostSale'));

interface ISingleFlowRouterProps {
    checkout?: ReactNode;
    postSale?: ReactNode;
    renderErrorPage?: ReactNode;
}

const NotFoundError = (): JSX.Element => {
    console.warn(`[router]: Unknown route ${window.location.pathname}`);
    return <ErrorPage type={ErrorPageTypes.NOT_FOUND} />;
};

export const SingleFlowRouter = ({ checkout, postSale, renderErrorPage }: ISingleFlowRouterProps): JSX.Element => {
    const { routerPath } = useTenantConfig<ITenantConfig>();
    const buildRoutePath = routePathGenerator(routerPath);

    return (
        <Suspense fallback={<Spinner />}>
            <BrowserRouter>
                <Routes>
                    <Route
                        path={buildRoutePath.ROOT}
                        element={<Navigate to={`${buildRoutePath.CHECKOUT}${location.search}`} replace />}
                    />
                    <Route path={buildRoutePath.CHECKOUT} element={checkout || <Checkout />} />
                    <Route path={buildRoutePath.POST_SALE} element={postSale || <PostSale />} />
                    <Route path="*" element={renderErrorPage || <NotFoundError />} />
                </Routes>
            </BrowserRouter>
        </Suspense>
    );
};
